import { createStore, combineReducers, applyMiddleware } from 'redux';
import rootReducer from '../reducers';
import { createLogger } from 'redux-logger';
import * as CONSTANTS from '../../config';

export default CONSTANTS.ENVIRONMENT_TYPE === 'PRODUCTION' ?
  createStore(combineReducers(rootReducer)) :
  createStore(combineReducers(rootReducer), applyMiddleware(createLogger({ collapsed: true })));